<template>
  <nav v-if="!disablePagination" class="flex flex-wrap items-center justify-between gap-3 px-1 md:w-full">
    <Flex gap-3 items-center class="min-w-1/2">
      <div class="text-gray-500">
        Exibindo
        <b>{{ totalPages > 1 ? modelValue * limit - limit + 1 : modelValue * limit - limit + 1 }}</b> à <b>{{ modelValue * limit - (limit - limit) }}</b> de
        <b>{{ totalItems }}</b> itens.
      </div>
      <slot name="left" />
    </Flex>
    <Flex gap-8 items-center justify-end class="min-w-1/2">
      <SelectTable v-model="modelLimit" :items="statusItems" up class="w-28" placeholder="" v-if="totalItems > 20" />

      <ul v-if="totalPages > 1" class="inline-flex items-center h-10 rounded-lg border border-slate-300 divide-x divide-slate-300 text-[#5F6368]">
        <li :class="{ [disableClass]: currentPage == 1 }" @click="previousPage">
          <NavButton class="border-e-0 border-slate-300 rounded-s-lg w-[60px]" icon="fa-solid fa-chevron-left mx-2" />
        </li>

        <div v-if="totalPages < 4" class="flex items-center divide-x divide-slate-300">
          <li v-for="i in totalPages" :key="i" @click="goToPage(i)">
            <NavButton :class="[`${currentPage === i ? activeClass : borderClass}`]">
              {{ i }}
            </NavButton>
          </li>
        </div>

        <div v-else class="flex items-center divide-x divide-slate-300">
          <li @click="goToPage(1)">
            <NavButton :class="[`${currentPage == 1 ? activeClass : borderClass}`]">1</NavButton>
          </li>

          <li v-if="currentPage > 3" class="relative">
            <NavButton> ... </NavButton>
          </li>

          <li v-if="currentPage > 2" @click="goToPage(currentPage - 1)">
            <NavButton :class="borderClass">
              {{ currentPage - 1 }}
            </NavButton>
          </li>

          <li v-if="currentPage !== 1 && currentPage !== totalPages" @click="goToPage(currentPage)">
            <NavButton :class="activeClass">
              {{ currentPage }}
            </NavButton>
          </li>

          <li v-if="currentPage < totalPages - 1" @click="goToPage(currentPage + 1)">
            <NavButton :class="borderClass">
              {{ currentPage + 1 }}
            </NavButton>
          </li>

          <li v-if="currentPage < totalPages - 2" class="relative">
            <NavButton> ... </NavButton>
          </li>

          <li v-if="lastPage" @click="goToPage(lastPage)">
            <NavButton :class="[`${currentPage == lastPage ? activeClass : borderClass}`]">
              {{ lastPage }}
            </NavButton>
          </li>
        </div>
        <li :class="{ [disableClass]: currentPage == lastPage }" @click="nextPage">
          <NavButton class="border-s-0 rounded-e-lg border-slate-300 w-[60px]" icon="fa-solid fa-chevron-right mx-2" />
        </li>
      </ul>
    </Flex>
  </nav>
</template>

<script setup>
import { ref, onMounted, watch, computed } from 'vue'

const emit = defineEmits(['update:modelValue', 'update:limit'])

const props = defineProps({
  disablePagination: {
    type: Boolean,
    default: false,
  },
  limit: { type: Number, default: 10 },
  totalItems: Number,
  totalPages: Number,
  modelValue: {
    type: Number,
    default: 1,
  },
})

const activeClass = ref('bg-primary-500 hover:bg-primary-600 text-white ')

const borderClass = ref('hover:bg-gray-100')
const currentPage = ref(1)
const searchPageValue = ref(null)
const disableClass = ref('opacity-50')
const isOpenSearch = ref(false)

const modelLimit = ref(props.limit)

const statusItems = ref([
  { label: '20', value: 20 },
  { label: '50', value: 50 },
  { label: '100', value: 100 },
  { label: '200', value: 200 },
  // { label: '500', value: 500 },
])

const goToPage = (pageNumber) => {
  let page = Number(searchPageValue.value ?? pageNumber)

  if (!Number.isFinite(page) || page <= 0 || page > props.totalPages) {
    page = 1
  }

  currentPage.value = page
  searchPageValue.value = null
  isOpenSearch.value = false
}

const openSearchPage = () => {
  isOpenSearch.value = !isOpenSearch.value
}

const nextPage = () => {
  if (currentPage.value < lastPage.value) {
    currentPage.value++
  }
}

const pageCurrentHandler = () => {
  return currentPage.value !== props.totalPages
}

const previousPage = () => {
  if (currentPage.value > 1) {
    currentPage.value--
  }
}

const penultimatePage = computed(() => {
  return props.totalPages > 1 ? props.totalPages - 1 : null
})

const lastPage = computed(() => {
  return props.totalPages
})

watch(
  () => props.modelValue,
  (newVal) => {
    currentPage.value = newVal
  },
)

watch(currentPage, (page) => {
  emit('update:modelValue', page)
})

watch(
  () => props.actualPage,
  () => {
    currentPage.value = 1
  },
)

watch(
  () => modelLimit.value,
  (newValue) => {
    emit('update:limit', newValue)
  },
)

onMounted(() => {
  currentPage.value = props.modelValue
})
</script>
